import { PUBLIC_TINYBIRD_API_KEY, PUBLIC_TINYBIRD_VIDEO_POSITION_ENDPOINT_KEY } from '$env/static/public';

export type ActivityType = 'started' | 'paused' | 'completed' | 'heartbeat' | "seeked_played" | "seeked_paused";

export type ActivityCreateDto = {
  user_id: string;
  activity_type: ActivityType;
  last_video_position_ms: number;
  lesson_id: string;
  lesson_slug?: string;
  lesson_name?: string;
  course_id: string;
  course_slug?: string;
  course_name?: string;
  heartbeat_interval_ms: number;
};

class ActivityService {
  public createViewActivity = async (dto: ActivityCreateDto) => {
    this.sendEvents('dsd_video_event', [dto]);
  }

  /**
   * Takes the events and sends them to Tinybird.
   */
  private sendEvents = async (eventName: "dsd_video_event", events: Array<ActivityCreateDto>) => {
    const headers = {
      'Authorization': `Bearer ${PUBLIC_TINYBIRD_API_KEY}`,
    };

    const body = events.map(e => JSON.stringify({ ...e, timestamp: new Date().toISOString() })).join('\n');

    const rawResponse = await fetch(`https://api.tinybird.co/v0/events?name=${eventName}`, {
      method: 'POST',
      body,
      headers: headers,
    });
    const content = await rawResponse.json();

    return content;
  }

  /**
   * Gets the last watched video position of a specific lesson for a user 
   * based on the user id and the respective lesson through the lesson slug.
   * @param userId The id of the user.
   * @param lessonSlug The lesson slug.
   * @returns Either 0 if no last video position was found or 
   * the last video position in milliseconds.
   */
  public getLastVideoPosition = async (userId: string, lessonId: string) => {
    // Default to the initial start position of the video.
    let lastVideoPosition: number = 0;
    const headers = {
      'Authorization': `Bearer ${PUBLIC_TINYBIRD_VIDEO_POSITION_ENDPOINT_KEY}`,
    }

    let requestUrl: URL = new URL('https://api.tinybird.co/v0/pipes/most_recent_last_video_position.json');
    requestUrl.searchParams.append('user_id', userId);
    requestUrl.searchParams.append('lesson_id', lessonId);

    const result = await fetch(requestUrl, {
      headers,
    })
      .then(response => response.json())
      .then(r => r)
      .catch(error => error.toString());

    if (!result.data) {
      console.error('Error: Could not fetch the last watched video position');
    } else if (result.data.length === 0) {
      lastVideoPosition = 0;
    } else {
      lastVideoPosition = result.data[0].last_video_position_ms;
    }

    return lastVideoPosition;
  }
}

export const activityService = new ActivityService();
